module.exports = __webpack_public_path__ + "img/12_8.99863c4d.png";